import styled from "styled-components";
import { FAQCategory } from "../../data/faqData";
import FAQItem from "./FAQItem";

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;

  @media (max-width: 767px) {
    gap: 30px;
  }
`;

const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CategoryTitle = styled.h2`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 8px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};

  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface FAQAccordionProps {
  categories: FAQCategory[];
}

const FAQAccordion = ({ categories }: FAQAccordionProps) => {
  return (
    <AccordionWrapper>
      {categories.map((category) => (
        <CategorySection key={category.title}>
          <CategoryTitle>{category.title}</CategoryTitle>
          <ItemsWrapper>
            {category.items.map((item, index) => (
              <FAQItem
                key={`${category.title}-${index}`}
                question={item.question}
                answer={item.answer}
              />
            ))}
          </ItemsWrapper>
        </CategorySection>
      ))}
    </AccordionWrapper>
  );
};

export default FAQAccordion;
